export const CLIP = 'clip';
export const EPISODE = 'episode';
export const MARATHON = 'marathon';
export const STREAM = 'stream';


// WEBPACK FOOTER //
// ./src/player/videoSource/videoTypes.js